import { render } from "./Music.vue?vue&type=template&id=0a689f94"
import script from "./Music.vue?vue&type=script&lang=js"
export * from "./Music.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__